module.exports = __webpack_public_path__ + "static/media/G1-16-Pyetra-Vlachos-cod36.516dff6f.png";